module.exports = __webpack_public_path__ + "e81964f0003641315966b0ec82d2e01f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/atlassian_2022_chart.png
// module id = 1636
// module chunks = 0